import { Ref } from "@tblabs/truffle";
import { BasketItemType } from "./BasketItemType";
import { OrderProductOption } from "./ProductOption";
import { RawBasketItem } from "./RawBasketItem";
import { ProductInfo } from "./Product";
import { v4 as uuidv4 } from "uuid";
import { Product } from "../../Shop/Product";
import { ProductOption } from "../../Shop/ProductOption";


export abstract class BasketItem
{
    public abstract Type: BasketItemType;
    public abstract get AsString(): string;

    public Id: string = "";
    public ProductSerialNumber = new Ref<string>("");
    public AccessData = new Ref<string>("");
    public ProductInfo: ProductInfo;
    public Option: OrderProductOption;
    public Quantity = new Ref<number>(1);
    public TotalPrice = new Ref<number>(0);

    constructor(raw: Partial<RawBasketItem>)
    {
        this.Id = raw.Id || uuidv4();
        this.ProductSerialNumber.value = raw.ProductSerialNumber || "";
        this.AccessData.value = raw.AccessData || "";
        this.ProductInfo = raw.ProductInfo || {} as ProductInfo;
        this.Option = raw.Option || {} as OrderProductOption;
        this.Quantity.value = raw.Quantity || 1;
        this.TotalPrice.value = raw.TotalPrice || 0;
    }

    public get AsRaw(): RawBasketItem
    {
        return ({
            Id: this.Id,
            Type: this.Type,
            ProductSerialNumber: this.ProductSerialNumber.value,
            AccessData: this.AccessData.value,
            ProductInfo: this.ProductInfo,
            Option: this.Option,
            Quantity: this.Quantity.value,
            TotalPrice: this.TotalPrice.value,
        } as RawBasketItem);
    }

    public Set(product: Product, option: ProductOption): void
    {
        this.ProductInfo.Id = product?.Id || "";
        this.ProductInfo.Origin = "website";
        this.ProductInfo.Name = product?.BasketName?.value || "";
        this.ProductInfo.Link = "https://specteam.pl/#produkt/" + (product?.Url?.value || "");
        this.ProductInfo.Category = product?.CategoryId?.value || "";
        this.ProductInfo.Picture = product?.Images?.Items?.[0]?.MiniUrl?.value || "";
        this.ProductInfo.Prices = product?.RentPrices?.Items?.map(x => `${x.Days?.value} dni: ${x.Value?.value} zł`)?.join("\n") || "";
        this.ProductInfo.Tutorial = product?.TutorialLink?.value || "";

        this.Option.Id = option?.Url?.value || "";
        this.Option.Name = option?.Label?.value || "";
    }
}
